const newsletter = {
    en: {
        title: "WANT TO BE THE FIRST?",
        subttl: "Back in the olden days, you couldn’t get hold of exclusive information without having to undergo torture, walk the plank or be subjected to any keelhauling. These days you just need to send us an e-mail and hey presto!",
        placeholder: "Enter your e-mail address",
        button: "Sign up",
        error: "Body of a thousand whales! This email address has already been entered by someone else! Enter another email address.",
        emailExist: "Body of a thousand whales! This email address has already been entered by someone else! Enter another email address.",
    },
    ka: {
        title: "გსურს, პირველმა გაიგო ყველაფერი\u202F?",
        subttl: "ოდესღაც ექსკლუზიური ინფორმაციის მოსაპოვებლად ნამდვილი მეკობრის თავგადასავალი იყო საჭირო. დღეს კი საკმარისია შენი ელფოსტა მოგვწერო — და ეგაა!",
        placeholder: "შეიყვანეთ თქვენი ელფოსტის მისამართი",
        button: "რეგისტრაცია",
        error: "ათასი ვეშაპის სხეულო! ეს ელფოსტის მისამართი უკვე სხვამ შეიყვანა! შეიყვანეთ სხვა ელფოსტის მისამართი.",
        emailExist: "ათასი ვეშაპის სხეულო! ეს ელფოსტის მისამართი უკვე სხვამ შეიყვანა! შეიყვანეთ სხვა ელფოსტის მისამართი.",
    },
};

export {
    newsletter
};
